import React, { useState } from 'react';
import { recordPayment } from '../utils/api';
import './_Modal.css';
import './_Buttons.css';

const RecordPaymentModal = ({ invoiceId, isOpen, onClose, onPaymentRecorded }) => {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [supplierName, setSupplierName] = useState('');
  const [supplierId, setSupplierId] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const paymentData = {
        amount: Math.round(parseFloat(amount) * 100),
        date,
      };
      if (supplierName) {
        paymentData.supplier_.name = supplierName;
      }
      if (supplierId) {
        paymentData.supplier_id = supplierId;
      }
      await recordPayment(invoiceId, paymentData);
      if (onPaymentRecorded) {
        onPaymentRecorded();
      }
      onClose();
    } catch (error) {
      setError('Failed to record payment');
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>&times;</button>
        <h2>Record Payment</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              id="amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Amount"
              required
            />
          </div>
          <div className="form-group">
            <input
              id="date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              placeholder="Date"
              required
            />
          </div>
          <div className="form-group">
            <input
              id="supplierName"
              type="text"
              value={supplierName}
              onChange={(e) => setSupplierName(e.target.value)}
              placeholder="Supplier Name"
            />
          </div>
          <div className="form-group">
            <input
              id="supplierId"
              type="text"
              value={supplierId}
              onChange={(e) => setSupplierId(e.target.value)}
              placeholder="Supplier Payment ID"
            />
          </div>
          <div className='actions-centered'>
            <button type="button" onClick={onClose} className='cancel-button text-button'>Cancel</button>
            <button type="submit" className='submit-button text-button'>Record Payment</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RecordPaymentModal;
